import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CaretLeft, Clock, User } from "@phosphor-icons/react";
import { getBlog } from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  useEffect(() => { getBlog(slug).then(setB).catch(() => {}); }, [slug]);
  if (!b) return <div className="max-w-3xl mx-auto p-16 text-brand-muted">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 py-16" data-testid="blog-detail-page">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-brand-muted hover:text-brand-ink mb-10" data-testid="back-to-blog">
        <CaretLeft size={16} /> All articles
      </Link>
      <div className="text-xs uppercase tracking-[0.28em] text-brand-sage mb-5">{b.category}</div>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">{b.title}</h1>
      <div className="mt-6 flex flex-wrap gap-5 text-sm text-brand-muted">
        <span className="inline-flex items-center gap-2"><User size={16} /> {b.author}</span>
        <span className="inline-flex items-center gap-2"><Clock size={16} /> {b.read_time} min read</span>
        <span>Published {b.published_at}</span>
      </div>
      <div className="mt-10 aspect-[16/9] rounded-3xl overflow-hidden bg-[#E8ECE4]">
        <img src={b.image} alt={b.title} className="w-full h-full object-cover" />
      </div>
      <div className="mt-12 space-y-6 text-lg leading-[1.8] text-brand-ink font-sans">
        {b.content.split("\n\n").map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </article>
  );
}
